export default "__VITE_ASSET__B2G68fc7__"